import EndPointConfig from "../../models/api/endPointConfig";

const controller = "advancedconfiguration";

export const AdvancedConfigurationEP2: EndPointConfig[] = [
  new EndPointConfig().setMethod('PATCH').setController(controller).setPattern('{id}/check').setAlias('CheckAdvancedConfigurationsCoincidences'),
];
